import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: []
})
export class PrivacyPolicyComponent {
  constructor() {
    window.scroll(0, 0);
  }
}
